export const typeTypes = {
    loading: "LOADING_TYPE",
    delete: "DELETE_TYPE",
    loadedOne: "LOADED_TYPE",
    loadedMultiple: "LOADED_TYPES",
    success: "SUCCESS_TYPE",
    restore: "RESTORE_TYPE",
    hardDelete: "HARDDELETE_TYPE",
};
